<template>
  <loading v-if="isLoading"></loading>
  <no-auth v-else-if="!hasAuthorize.getById"></no-auth>
  <not-found v-else-if="!cycle"></not-found>
  <div v-else class="container-fluid" id="cycle-detail">
    <ActionBar
      :creatingPdf="creatingPdf"
      @create:pdf="createPdf"
      @refresh="getCycle"
      :cycle="cycle"
    ></ActionBar>
    <CycleInfo :creatingPdf="creatingPdf" :cycle="cycle"></CycleInfo>
    <CycleTabs v-if="!creatingPdf" :cycle="cycle"></CycleTabs>
  </div>
</template>

<script>
import Loading from "../Base/Loading/Loading.vue";
import NotFound from "../Base/NotFound.vue";
import ActionBar from "./ActionBar.vue";
import CycleInfo from "./CycleInfo.vue";
import CycleTabs from "./Tabs/CycleTabs.vue";
import html2pdf from "html2pdf.js";
import authorize from "../Cycles/authorize";

export default {
  components: { Loading, NotFound, ActionBar, CycleInfo, CycleTabs },
  mixins: [authorize],
  data() {
    return {
      cycleId: null,
      isLoading: true,
      cycle: null,
      creatingPdf: false,
    };
  },
  methods: {
    async getCycle() {
      this.isLoading = true;
      const response = await this.$store.dispatch("getCycleById", {
        id: this.$route.params.cycleId,
      });
      if (response.message === "OK") {
        this.cycle = response.data;
      }
      this.isLoading = false;
    },
    async createPdfBlob() {
      const element = document.getElementById("cycle-detail");
      const opt = {
        margin: [23.5, 1, 40, 1],
        filename: this.cycle.serialNumber + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      };

      const footerImg = "/pdf-footer.png";
      const headerImg = "/pdf-header.png";
      //const footerLogo = ;
      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          var totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            // set footer to every page
            pdf.setPage(i);
            // set footer font
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.addImage(
              footerImg,
              "png",
              10,
              pdf.internal.pageSize.getHeight() - 30,
              pdf.internal.pageSize.getWidth() - 20,
              30
            );
            pdf.addImage(
              headerImg,
              "png",
              10,
              0,
              pdf.internal.pageSize.getWidth() - 20,
              25
            );
            // pdf.addImage(
            //   footerLogo,
            //   "png",
            //   0,
            //   0,
            //   pdf.internal.pageSize.getWidth(),
            //   0.3
            // );
          }
          window.open(pdf.output("bloburl"), "_blank");
          this.$store.dispatch("SET_ACTION_MODAL", {
            isLoading: false,
            status: false,
          });
          this.creatingPdf = false;
          this.$emit("pdfCreated");
        });
      return "";
    },
    blobToFile(blob, fileName) {
      return new File([blob], fileName, { type: "application/pdf" });
    },
    async createPdf() {
      this.creatingPdf = true;
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("common.creatingPdf"),
        duration: 20 * 60 * 1000,
      });
      setTimeout(async () => {
        await this.createPdfBlob();
      }, 500);
    },
  },
  mounted() {
    this.getCycle();
  },
};
</script>

<style></style>
